// Import
import MuseUI from 'muse-ui'
import Vue from 'vue'
import Vuex from 'vuex'
import VuexI18n from 'vuex-i18n'
import axios from 'axios'
import router from './router'
import { detect } from 'detect-browser'

// Use Vuex
Vue.use(Vuex)
Vue.use(VuexI18n)

export default new Vuex.Store({
  state: {
    url: {
      api: process.env.VUE_APP_VOX_URL_API, // RESTful API location
      storage: process.env.VUE_APP_VOX_URL_STORAGE, // Resources location
      casLogout: process.env.VUE_APP_VOX_URL_CAS // CAS Logout URL
    },
    auth: { // Auth information
      token: "not updated", // Token
      user: { // User object
        roles: []
      },
      authorized: false, // Flag to indicate authorized status
      intervalFetch: 360000, // Time in miliseconds for checking auth valid or not
    },
    settings: {},
    flag: { // Flag used in global state
      triggerRefresh: false,
      fetchedSettings: false,
      previewMode: true,
      triggerNotification: false,
    },
    lti: { // LTI information
      turnitin: {
        url: process.env.VUE_APP_VOX_URL_TURNITIN
      }
    },
    loading: {
      fetching: false,
      timeout: null
    },
    browser: detect(),
    uploadQueue: [],
    exportQueue: [],
    bookmarks: [],
  },
  getters: { // Getters of parameters
    authorized (state) {
      return state.auth.authorized;
    },
    urlApi (state) {
      return state.url.api;
    },
    urlStorage (state) {
      return state.url.storage;
    },
    urlCasLogout (state) {
      return state.url.casLogout;
    },
    triggerRefresh (state) {
      return state.flag.triggerRefresh;
    },
    triggerNotification (state) {
      return state.flag.triggerNotification;
    },
    previewMode (state) {
      return state.flag.previewMode;
    },
    isAdmin (state) {
      if(state.auth.user.hasOwnProperty('roles')) {
        return state.auth.user.roles.includes('admin');
      } else {
        return false;
      }
    },
    isTeacher (state) {
      if(state.auth.user.hasOwnProperty('roles')) {
        return state.auth.user.roles.includes('teacher') || state.auth.user.roles.includes('admin');
      } else {
        return false;
      }
    },
    isAssistant (state) {
      if(state.auth.user.hasOwnProperty('roles')) {
        return state.auth.user.roles.includes('teacher') || state.auth.user.roles.includes('admin') || state.auth.user.roles.includes('assistant');
      } else {
        return false;
      }
    },
    isStudent (state) {
      if(state.auth.user.hasOwnProperty('roles')) {
        return state.auth.user.roles.includes('teacher') || state.auth.user.roles.includes('admin') || state.auth.user.roles.includes('assistant') || state.auth.user.roles.includes('student');
      } else {
        return false;
      }
    },
    uploadQueue(state) {
      return state.uploadQueue;
    },
    exportQueue(state) {
      return state.exportQueue;
    }
  },
  mutations: { // Operations
    login (state, payload) { // Login
      setCookie("token", payload.token, 1);
      state.auth.token = payload.token;
      state.auth.user = payload.user;
      state.auth.authorized = true;
      console.log(payload.path);
      router.push({
        path: payload.path
      });
    },
    logout (state) { // Logout
      eraseCookie('token');
      state.auth.user = {
        name: "",
        type: "",
        username: "",
        profile: "",
        passwordLength: 0
      };
      state.auth.authorized = false;
      state.auth.token = "";
      state.settings = {};
      MuseUI.theme.use("default-light");
    },
    loginByCas (state, payload) { // Login by CAS
      setCookie("token", payload.token, 1);
      state.auth.token = payload.token;
      state.auth.user = payload.user;
      state.auth.authorized = true;
      console.log(payload.path);
      router.push({
        path: payload.path
      });
    },
    triggerRefresh (state) {
      state.flag.triggerRefresh = !state.flag.triggerRefresh;
    },
    previewMode (state) { // Trigger refresh action
      state.flag.previewMode = !state.flag.previewMode;
    },
    updateRoute (state, router) {
      axios.put(state.url.api + "user", {
        'route': router.fullPath,
        'browser': state.browser
        }, {
        headers: {
          token: state.auth.token,
          'content-type': 'application/json'
        },
        }
      );
    },
    fetching (state, fetching) {
      if(fetching) {
        clearTimeout(state.loading.timeout);
        state.loading.fetching = true;
      } else {
        state.loading.timeout = setTimeout(() => {
          state.loading.fetching = false;
        }, 1000);
      }
    },
    uploadQueueAppend (state, payload) {
      state.uploadQueue.push(payload);
      state.flag.triggerNotification = !state.flag.triggerNotification;
    },
    uploadQueuePop (state, uploadId) {
      for (var i = state.uploadQueue.length - 1; i >= 0; --i) {
        if (state.uploadQueue[i].uploadId == uploadId) {
          state.uploadQueue.splice(i,1);
        }
      }
    },
    exportQueueAppend (state, payload) {
      state.exportQueue.push(payload);
      state.flag.triggerNotification = !state.flag.triggerNotification;
    },
    exportQueuePop (state, exportId) {
      for (var i = state.exportQueue.length - 1; i >= 0; --i) {
        if (state.exportQueue[i].exportId == exportId) {
          state.exportQueue.splice(i,1);
        }
      }
    },
    setSettings (state, payload) {
      state.settings = {};
      Object.keys(payload).forEach(key => {
        state.settings[key] = payload[key];
      });
      state.flag.fetchedSettings = true;
    },
    updateSettings (state, payload) {
      Object.keys(payload).forEach(key => {
        state.settings[key] = payload[key];
      });
    },
    bookmarkSave(state, payload) {
      state.bookmarks = payload;
    },
    bookmarkAppend(state, payload) {
      var data = payload;
      var exist = state.bookmarks.findIndex(item => data.id === item.id && data.type === item.type);
      if(exist === -1) {
        state.bookmarks.push(payload);
      }
    },
    bookmarkRemove(state, payload) {
      var data = payload;
      var exist = state.bookmarks.findIndex(item => data.id === item.id && data.type === item.type);
      if(exist !== -1) {
        var index = state.bookmarks.findIndex(item => data.id === item.id && data.type === item.type);
        state.bookmarks.splice(index, 1);
      }
    }

  },
  actions: {
    fetchSettings ({ commit, state }, payload) {
      axios.get(state.url.api + "settings", {
        headers: {
          token: state.auth.token
        }
        }
      ).then(response => {
        var settings = response.data.data.settings;
        
        // Set language
        if(!settings.hasOwnProperty('lang')) {
          settings.lang = "en";
        } else if(settings.hasOwnProperty('lang') && (settings.lang !== 'en' || settings.lang !== 'zh')) {
          settings.lang = "en";
        }
        Vue.i18n.set(settings.lang);
        
        // Set theme
        if(!settings.hasOwnProperty('theme')) {
          settings.theme = 'default-light';
        } else {
          if(settings.theme === 'custom-light') {
            MuseUI.theme.add('custom-light', settings.custom, 'light');
          }
          if(settings.theme === 'custom-dark') {
            MuseUI.theme.add('custom-dark', settings.custom, 'dark');
          }
        }
        MuseUI.theme.use(settings.theme);
        
        commit('setSettings', settings);
      });
    },
    updateSettings ({ commit, state }, settings) {
      // Set language
      if(settings.hasOwnProperty('lang')) {
        Vue.i18n.set(settings.lang);
      }
      
      // Set theme
      if(settings.hasOwnProperty('theme')) {
        MuseUI.theme.use(settings.theme);
      }
      axios.put(state.url.api + "settings", settings,
        {
        headers: {
          token: state.auth.token,
          'content-type': 'application/json'
        },
        }
      ).then(() => {
        commit('updateSettings', settings);
      });
    },
    bookmarkUp ({ commit, state }, payload) {
      var data = JSON.parse(JSON.stringify(payload));
      delete data['object'];
      axios.post(state.url.api + "bookmark", data, {
        headers: {
          token: state.auth.token,
          'content-type': 'application/json'
        },
      }).then(() => {
        commit('bookmarkAppend', payload);
      });
    },
    bookmarkDown ({ commit, state }, payload) {
      var data = JSON.parse(JSON.stringify(payload));
      delete data['object'];
      axios.delete(state.url.api + "bookmark", {
        headers: {
          token: state.auth.token,
          'content-type': 'application/json'
        },
        data: data
      }).then(() => {
        commit('bookmarkRemove', payload);
      });
    },
    bookmarkList ({ commit, state }) {
      axios.get(state.url.api + "bookmark", {
        headers: {
          token: state.auth.token,
          'content-type': 'application/json'
        }
      }).then(res => {
        commit('bookmarkSave', res.data.data.bookmarks);
      });
    },
  }
});

// Set cookie helper class
function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

// Erase cookie helper class
function eraseCookie(name) {
  document.cookie = name + '=; Max-Age=-99999999;';
}
